import React from "react";
import { ILinkFunc } from "../../lib/util";
import { EHeaderLayout } from "./Header";

export interface SubNavGroup {
  groupTitle?: string;
  /**
 * Flag field which indicates if the group tile will be a link
 */
  isLinkTitle?: boolean;
  /**
   * Field for group link title
   */
  titleLink?: string;
  links: { label: string; url: string }[];
}

export interface ISubNavProps {
  className?: string;
  subNavGroups: SubNavGroup[];
  linkFunc?: ILinkFunc;
  layout?: EHeaderLayout;
  setNavOpen?: (value: any) => any;
  setSubOpen?: (value: any) => any;
}

const SubNav: React.FC<ISubNavProps> = (props) => {
  const linkf = props.linkFunc || ((props) => <a {...props} />);
  const layoutClasses = {
    container: "",
    list: "",
    linkTitleList: "",
    linkTitle: "",
  };

  switch (props.layout) {
    case EHeaderLayout.top:
    case EHeaderLayout.top_spread:
      layoutClasses.container =
        "bg-body-bg z-30 md:absolute top-full md:flex gap-7 md:mt-3 md:p-7";
      layoutClasses.list =
        "before:content-[attr(aria-label)] before:leading-6 whitespace-nowrap";
      layoutClasses.linkTitleList =
        "flex flex-col whitespace-nowrap";
      layoutClasses.linkTitle = "leading-6";
      break;
    case EHeaderLayout.side:
      layoutClasses.container =
        "inverted z-30 md:fixed top-full md:top-0 md:right-0 md:left-1/2 lg:left-[60%] bottom-0 gap-7 py-6 md:py-20 md:px-10 md:overflow-y-scroll";
      layoutClasses.list =
        "inverted flex flex-col gap-3 lg:gap-4 hover:text-inherit before:content-[attr(aria-label)] before:leading-6 before:uppercase text-xl md:text-2xl pl-6 before:-ml-6 md:py-6 whitespace-nowrap";
      layoutClasses.linkTitleList =
        "inverted flex flex-col gap-3 lg:gap-4 hover:text-inherit text-xl md:text-2xl pl-6 md:py-6 whitespace-nowrap";
      layoutClasses.linkTitle = "leading-6 uppercase -ml-6";
      break;
  }

  const toggleNav = () => {
    props.setSubOpen!(-1);
    props.setNavOpen!(false);
  };

  return (
    <div className={`${layoutClasses.container} ${props.className}`}>
      {props.subNavGroups.map((group: SubNavGroup, index: number) => {
        let groupElement: any
        if (!group.isLinkTitle) {
          groupElement = (
            <ul
              aria-label={group.groupTitle}
              className={`list-none ${layoutClasses.list}`}
              key={index}
            >
              {group.links.map((link, index) => (
                <li key={index}>
                  {linkf({
                    href: link.url,
                    children: link.label,
                    onClick: toggleNav
                  })}
                </li>
              ))}
            </ul>
          )
        }
        else {
          groupElement = (
            <ul
              aria-label={group.groupTitle}
              className={`list-none ${layoutClasses.linkTitleList}`}
              key={index}
            >
              <li key={`${index}_0`}>
                {linkf({
                  href: group.titleLink,
                  children: group.groupTitle,
                  onClick: toggleNav,
                  className: `link-title-item ${layoutClasses.linkTitle}`
                })}
              </li>
              {group.links.map((link, index) => (
                <li key={(index)}>
                  {linkf({
                    href: link.url,
                    children: link.label,
                    onClick: toggleNav,
                  })}
                </li>
              ))}
            </ul>
          )
        }
        return (groupElement)
      })}
    </div>
  );
};

export default SubNav;
